// App Styles
import "./../css/app.scss";

// Vendor Scripts and Styles
import "bootstrap";
import "bootstrap-select";
import "bootstrap-select/dist/css/bootstrap-select.css";
import "bootstrap-notify";
import "bootstrap-switch";
import "bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css";
import "datatables.net";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "flatpickr";
import "flatpickr/dist/themes/dark.css";
import "jquery-mask-plugin";
import "jquery-ajax-unobtrusive";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "nouislider";
import "nouislider/distribute/nouislider.css";

// App Scripts
import { accountPrograms } from "./modules/accountPrograms";
import { activityReport } from "./modules/activityReport";
import { activityReportFilters } from "./modules/activityReportFilters";
import { addArea } from "./modules/addArea";
import { addAttestation } from "./modules/addAttestation";
import { addComment } from "./modules/addComment";
import { addCourse } from "./modules/addCourse";
import { addCourseEdition } from "./modules/addCourseEdition";
import { addDisclosureForm } from "./modules/addDisclosureForm";
import { addPerson } from "./modules/addPerson";
import { addPersonSite } from "./modules/addPersonSite";
import { addPersonToSite } from "./modules/addPersonToSite";
import { addRegion } from "./modules/addRegion";
import { addressFormatter } from "./framework/addressFormatter";
import { addRole } from "./modules/addRole";
import { addSite } from "./modules/addSite";
import { addSiteProgram } from "./modules/addSiteProgram";
import { alerts } from "./modules/alerts";
import { application } from "./application/application";
import { areas } from "./framework/areas";
import { areaTable } from "./modules/areaTable";
import { attestation } from "./modules/attestation";
import { attestationsDashboard } from "./modules/attestationsDashboard";
import { attestationsDashboardFilters } from "./modules/attestationsDashboardFilters";
import { attestationsSearch } from "./modules/attestationsSearch";
import { conflictOfInterest } from "./modules/conflictOfInterest";
import { countryState } from "./modules/countryState";
import { course } from "./modules/course";
import { courseApproverReport } from "./modules/courseApproverReport";
import { courseApproverReportFilters } from "./modules/courseApproverReportFilters"; 
import { courseBasicInfo } from "./modules/courseBasicInfo";
import { courseDashboard } from "./modules/courseDashboard";
import { courseDashboardFilters } from "./modules/courseDashboardFilters";
import { courseDocuments } from "./modules/courseDocuments";
import { courseEvaluation } from "./modules/courseEvaluation";
import { courseFacPostEvaluation } from "./modules/courseFacPostEvaluation";
import { courseFacPreEvaluation } from "./modules/courseFacPreEvaluation";
import { courseFacultyStudentEvaluation } from "./modules/courseFacultyStudentEvaluation";
import { courseFinancials } from "./modules/courseFinancials";
import { courseHistory } from "./modules/courseHistory";
import { courseProfile } from "./modules/courseProfile";
import { courseReport } from "./modules/courseReport";
import { courseReportAggregate } from "./modules/courseReportAggregate";
import { courseReportAggregateFilters } from "./modules/courseReportAggregateFilters";
import { courseReportFilters } from "./modules/courseReportFilters";
import { courseReportSummary } from "./modules/courseReportSummary";
import { courseReportSummaryFilters } from "./modules/courseReportSummaryFilters";
import { courseResults } from "./modules/courseResults";
import { courseSchedule } from "./modules/courseSchedule";
import { courseSearch } from "./modules/courseSearch";
import { courseSurveyReportFilters } from "./modules/courseSurveyReportFilters";
import { courseSurveyReportResponses } from "./modules/courseSurveyReportResponses";
import { courseSurveyReportStatistics } from "./modules/courseSurveyReportStatistics";
import { courseEvaluationReportFilters } from "./modules/courseEvaluationReportFilters";
import { courseEvaluationReportResponses } from "./modules/courseEvaluationReportResponses";
import { courseEvaluationReportStatistics } from "./modules/courseEvaluationReportStatistics";
import { courseFacPostEvaluationReportFilters } from "./modules/courseFacPostEvaluationReportFilters";
import { courseFacPostEvaluationReportResponses } from "./modules/courseFacPostEvaluationReportResponses";
import { courseFacPreEvaluationReportFilters } from "./modules/courseFacPreEvaluationReportFilters";
import { courseFacPreEvaluationReportResponses } from "./modules/courseFacPreEvaluationReportResponses";
import { courseFacultyStudentEvaluationReportStatistics } from "./modules/courseFacultyStudentEvaluationReportStatistics";
import { courseFacultyStudentEvaluationReportResponses } from "./modules/courseFacultyStudentEvaluationReportResponses";
import { courseFacultyStudentEvaluationReportFilters } from "./modules/courseFacultyStudentEvaluationReportFilters";
import { dashboardApproveCourseRequest } from "./modules/dashboardApproveCourseRequest";
import { dashboardApprovePostCourseReport } from "./modules/dashboardApprovePostCourseReport";
import { dashboardApproveSite } from "./modules/dashboardApproveSite";
import { dashboardManageDraftCourses } from "./modules/dashboardManageDraftCourses";
import { dashboardManageOpenCourses } from "./modules/dashboardManageOpenCourses";
import { dashboardTodo } from "./modules/dashboardTodo";
import { dateFormatter } from "./framework/dateFormatter";
import { disclosureFormReport } from "./modules/disclosureFormReport"
import { editAttestation } from "./modules/editAttestation";
import { ethosBank } from "./modules/ethosBank";
import { ethosBankAdmin } from "./modules/ethosBankAdmin";
import { expireRole } from "./modules/expireRole";
import { homeDashboard } from "./modules/homeDashboard";
import { instructorPortal } from "./modules/instructorPortal";
import { layout } from "./modules/layout";
import { orders } from "./modules/orders";
import { ordersShippingAddress } from "./modules/ordersShippingAddress";
import { passBankReport } from "./modules/passBankReport";
import { passBankReportFilters } from "./modules/passBankReportFilters";
import { peopleDashboard } from "./modules/peopleDashboard";
import { peopleDashboardFilters } from "./modules/peopleDashboardFilters";
import { peopleSearch } from "./modules/peopleSearch";
import { person } from "./modules/person";
import { personBasicInfo } from "./modules/personBasicInfo";
import { personReport } from "./modules/personReport";
import { personReportFilters } from "./modules/personReportFilters";
import { personSignature } from "./modules/personSignature";
import { programCourseType } from "./modules/programCourseType";
import { programReport } from "./modules/programReport";
import { programReportFilters } from "./modules/programReportFilters";
import { regions } from "./framework/regions";
import { regionTable } from "./modules/regionTable";
import { siteActivate } from "./modules/siteActivate";
import { siteAssignment } from "./modules/siteAssignment";
import { siteCourses } from "./modules/siteCourses";
import { siteDashboard } from "./modules/siteDashboard";
import { siteDashboardFilters } from "./modules/siteDashboardFilter";
import { siteDetails } from "./modules/siteDetails";
import { siteDetailsApproveSite } from "./modules/siteDetailsApproveSite";
import { siteProfile } from "./modules/siteProfile";
import { siteSearch } from "./modules/siteSearch";
import { siteTable } from "./modules/siteTable";
import { staffAuditReport } from "./modules/staffAuditReport";
import { staffAuditReportFilters } from "./modules/staffAuditReportFilters";
import { tag } from "./modules/tag";
import "./validations/emailAddressValidation";
import "./validations/requiredIfValidation";

// Assign to global "Atls" variable which makes modules accessible from web pages.
window.Atls = {
    accountPrograms: accountPrograms,
    activityReport: activityReport,
    activityReportFilters: activityReportFilters,
    addArea: addArea,
    addAttestation: addAttestation,
    addComment: addComment,
    addCourse: addCourse,
    addCourseEdition: addCourseEdition,
    addDisclosureForm: addDisclosureForm,
    addPerson: addPerson,
    addPersonSite: addPersonSite,
    addPersonToSite: addPersonToSite,
    addRegion: addRegion,
    addressFormatter: addressFormatter,
    addRole: addRole,
    addSite: addSite,
    addSiteProgram: addSiteProgram,
    alerts: alerts,
    application: application,
    areas: areas,
    areaTable: areaTable,
    attestation: attestation,
    attestationsDashboard: attestationsDashboard,
    attestationsDashboardFilters: attestationsDashboardFilters,
    attestationsSearch: attestationsSearch,
    conflictOfInterest: conflictOfInterest,
    countryState: countryState,
    course: course,
    courseApproverReport: courseApproverReport,
    courseApproverReportFilters: courseApproverReportFilters,
    courseBasicInfo: courseBasicInfo,
    courseDashboard: courseDashboard,
    courseDashboardFilters: courseDashboardFilters,
    courseDocuments: courseDocuments,
    courseEvaluation: courseEvaluation,
    courseFacPostEvaluation: courseFacPostEvaluation,
    courseFacPreEvaluation: courseFacPreEvaluation,
    courseFacultyStudentEvaluation: courseFacultyStudentEvaluation,
    courseFinancials: courseFinancials,
    courseHistory: courseHistory,
    courseProfile: courseProfile,
    courseReport: courseReport,
    courseReportAggregate: courseReportAggregate,
    courseReportAggregateFilters: courseReportAggregateFilters,
    courseReportFilters: courseReportFilters,
    courseReportSummary: courseReportSummary,
    courseReportSummaryFilters: courseReportSummaryFilters,
    courseResults: courseResults,
    courseSchedule: courseSchedule,
    courseSearch: courseSearch,
    courseSurveyReportFilters: courseSurveyReportFilters,
    courseSurveyReportResponses: courseSurveyReportResponses,
    courseSurveyReportStatistics: courseSurveyReportStatistics,
    courseEvaluationReportFilters: courseEvaluationReportFilters,
    courseEvaluationReportResponses: courseEvaluationReportResponses,
    courseEvaluationReportStatistics: courseEvaluationReportStatistics,
    courseFacPostEvaluationReportFilters: courseFacPostEvaluationReportFilters,
    courseFacPostEvaluationReportResponses: courseFacPostEvaluationReportResponses,
    courseFacPreEvaluationReportFilters: courseFacPreEvaluationReportFilters,
    courseFacPreEvaluationReportResponses: courseFacPreEvaluationReportResponses,
    courseFacultyStudentEvaluationReportStatistics: courseFacultyStudentEvaluationReportStatistics,
    courseFacultyStudentEvaluationReportResponses: courseFacultyStudentEvaluationReportResponses,
    courseFacultyStudentEvaluationReportFilters: courseFacultyStudentEvaluationReportFilters,
    dashboardApproveCourseRequest: dashboardApproveCourseRequest,
    dashboardApprovePostCourseReport: dashboardApprovePostCourseReport,
    dashboardApproveSite: dashboardApproveSite,
    dashboardManageDraftCourses: dashboardManageDraftCourses,
    dashboardManageOpenCourses: dashboardManageOpenCourses,
    dashboardTodo: dashboardTodo,
    dateFormatter: dateFormatter,
    disclosureFormReport: disclosureFormReport,
    editAttestation: editAttestation,
    ethosBank: ethosBank,
    ethosBankAdmin: ethosBankAdmin,
    expireRole: expireRole,
    homeDashboard: homeDashboard,
    instructorPortal: instructorPortal,
    layout: layout,
    orders: orders,
    ordersShippingAddress: ordersShippingAddress,
    passBankReport: passBankReport,
    passBankReportFilters: passBankReportFilters,
    peopleDashboard: peopleDashboard,
    peopleDashboardFilters: peopleDashboardFilters,
    peopleSearch: peopleSearch,
    person: person,
    personBasicInfo: personBasicInfo,
    personReport: personReport,
    personReportFilters: personReportFilters,
    personSignature: personSignature, 
    programCourseType: programCourseType,
    programReport: programReport,
    programReportFilters: programReportFilters,
    regions: regions,
    regionTable: regionTable,
    siteActivate: siteActivate,
    siteAssignment: siteAssignment,
    siteCourses: siteCourses,
    siteDashboard: siteDashboard,
    siteDashboardFilters: siteDashboardFilters, 
    siteDetails: siteDetails,
    siteDetailsApproveSite: siteDetailsApproveSite,
    siteProfile: siteProfile,
    siteSearch: siteSearch,
    siteTable: siteTable,
    staffAuditReport: staffAuditReport,
    staffAuditReportFilters: staffAuditReportFilters,
    tag: tag
};